// EventList.js
import React, { useEffect,useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Container, Input, Row, Col, Card, CardBody } from 'reactstrap';
//import '../../../assets/scss/page/event.scss';
import bgimg from '../../assets/images/faq-img.png';

import { ToastContainer, toast } from 'react-toastify';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
 
import {  baseURL } from '../../utils/cart';
//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect"; 
import {
  getEvents as onGetEvents,
  deleteEvent as onDeleteEvent
} from "../../slices/thunks";
 

const EventList = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const [eventToDelete, setEventToDelete] = useState(null);
  const user = useMemo(() => {
    try { return JSON.parse(sessionStorage.getItem('user')); } catch { return null; }
  }, []);
  const role = user?.role;
  const canViewRegistrations = role === 'employee2' || role === 'employee3';
  
  // Helper function to format date safely
  const formatEventDate = (dateString) => {
    if (!dateString) return null;
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return null;
      
      // Ensure we have a valid date
      if (date.getFullYear() < 1900 || date.getFullYear() > 2100) return null;
      
      // Month abbreviations
      const monthAbbreviations = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      
      return {
        month: date.getMonth() + 1,
        day: date.getDate(),
        year: date.getFullYear(),
        monthAbbr: monthAbbreviations[date.getMonth()],
        formattedDay: date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`
      };
    } catch (error) {
      console.error('Error parsing date:', dateString, error);
      return null;
    }
  };

  const selectLayoutState = (state) => state.Calendar;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (calender) => ({
      events: calender?.events, 
      isEventUpdated: calender?.isEventUpdated,
      isEventDeleted: calender?.isEventDeleted,
    })
  ); 
  const {
    events, isEventUpdated, isEventDeleted
  } = useSelector(selectLayoutProperties);
  
  // Sort events by start date in descending order (latest first) and then filter by search term
  const filteredEvents = useMemo(() => {
    // First sort events by start date in descending order
    const sortedEvents = [...events].sort((a, b) => {
      const dateA = formatEventDate(a.start || a.start_date || a.date);
      const dateB = formatEventDate(b.start || b.start_date || b.date);
      
      // Handle invalid dates by placing them at the end
      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;
      
      // Compare dates
      const timeA = new Date(a.start || a.start_date || a.date).getTime();
      const timeB = new Date(b.start || b.start_date || b.date).getTime();
      
      return timeB - timeA; // Descending order (latest first)
    });
    
    // Debug: Log the first few sorted events to verify sorting
    if (process.env.NODE_ENV === 'development' && sortedEvents.length > 0) {
      console.log('Events sorted by start date (latest first):', 
        sortedEvents.slice(0, 3).map(e => ({
          title: e.title,
          start: e.start || e.start_date || e.date,
          formattedDate: formatEventDate(e.start || e.start_date || e.date)?.monthAbbr + ' ' + 
                        formatEventDate(e.start || e.start_date || e.date)?.formattedDay
        }))
      );
    }
    
    // Then filter by search term
    return sortedEvents.filter(event =>
      event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      event.location.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [events, searchTerm]);
  // Handle delete event
  const handleDeleteEvent = () => {
    if (eventToDelete) {
      dispatch(onDeleteEvent(eventToDelete.id));
      setDeleteModal(false);
      setEventToDelete(null);
      // Events list will be automatically refreshed through the reducer
    }
  };

  // Open delete modal
  const openDeleteModal = (event) => {
    setEventToDelete(event);
    setDeleteModal(true);
  };

  useEffect(() => {
    dispatch(onGetEvents());   
  }, [dispatch]);

  // Handle event deletion - refresh events list when an event is deleted
  useEffect(() => {
    if (isEventDeleted) {
      // Show success message
      toast.success("Event deleted successfully!");
      // Refresh events list after deletion
      dispatch(onGetEvents());
    }
  }, [isEventDeleted, dispatch]);
  return ( 
<div className="page-content"> 
<Container fluid>
    <ToastContainer />
      <BreadCrumb title="Event List"  />
      <Row className='justify-content-end mb-3'>   
        <Col xl={4} lg={5} md={6} sm={8} xs={12}>  
          <Input
            type="search"
            placeholder="Search an event..."
            className="search-input event-search w-100"   
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
      </Row>

      {/* Events sorted by start date (latest first) */}
      <Row className="mb-3">
        <Col>
          <small className="text-muted">
            <i className="mdi mdi-sort-calendar-ascending me-1"></i>
            Events sorted by start date (latest first)
            {searchTerm && (
              <span className="ms-2">
                • Showing {filteredEvents.length} of {events.length} events
              </span>
            )}
          </small>
        </Col>
      </Row>

      <Row>
        {filteredEvents.map(event => (
          <Col xl={3} lg={4} md={6} sm={6} xs={12} className="mb-4" key={event.id}>
            <Card 
              tag={Link} 
              to={"/event-detail?event_id="+event.id}
              className="event-card overflow-hidden position-relative border-0"
            >
              <div 
                className="card-background"
                style={{ // 动态背景保留行内样式
                  backgroundImage: `url(${event.images.length>0?baseURL + "/file/event/image/" +event.images[0].image_url:bgimg})`,
                  backgroundColor: '#fff',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 1
                }}
              />
               
              
              <div className="date-container">
                <div className="text-center">
                  {(() => {
                    const dateInfo = formatEventDate(event.start);
                    return dateInfo ? (
                      <span 
                        className="fw-bold" 
                      >
                        {dateInfo.monthAbbr}
                        <br />
                        {dateInfo.formattedDay}
                      </span>
                    ) : (
                      <span className="text-muted small">No date</span>
                    );
                  })()}
                </div>
              </div>

              <CardBody className="position-relative d-flex flex-column justify-content-end"
                style={{padding:'0',zIndex: 3}}
              >
                <div className='card-content'>
                  <h3 className="mb-2">{event.title}</h3>
                  <p className="mb-0">{event.location||'...'}</p>
                  <div className="mt-2 d-flex gap-2">
                    {canViewRegistrations && (
                      <Link className="btn btn-outline-primary btn-sm" to={`/events/${event.id}/registrations`} onClick={(e) => e.stopPropagation()}>
                        View registrations
                      </Link>
                    )}
                    {(role === 'superadmin' || role === 'employee3') && (
                      <button 
                        className="btn btn-outline-danger btn-sm" 
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          openDeleteModal(event);
                        }}
                      >
                        <i className="ri-delete-bin-line me-1"></i>
                        Delete
                      </button>
                    )}
                  </div>
                </div>   
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row> 

      {/* Delete Modal */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => {
          setDeleteModal(false);
          setEventToDelete(null);
        }}
      />
    </Container>
  </div>
   
  );
};

 export default EventList;